import React, { useState, useEffect } from 'react';
import { pagesData } from '../data/pagesData';
import HeroSection from '../components/sections/HeroSection';
import VisionMissionSection from '../components/sections/VisionMissionSection';
import AboutPreview from '../components/sections/AboutPreview';
import AboutHeroSection from '../components/sections/AboutHeroSection';
import AboutCompanyOverviewSection from '../components/sections/AboutCompanyOverviewSection';
import AboutQualitySafetySection from '../components/sections/AboutQualitySafetySection';
import AboutProjectManagementSection from '../components/sections/AboutProjectManagementSection';
import BusinessScopeSection from '../components/sections/BusinessScopeSection';
import AboutVisionMissionGoalsSection from '../components/sections/AboutVisionMissionGoalsSection';
import AboutCoreValuesSection from '../components/sections/AboutCoreValuesSection';
import AboutWhyUsSection from '../components/sections/AboutWhyUsSection';
import AboutTestimonialsSection from '../components/sections/AboutTestimonialsSection';
import AboutCTASection from '../components/sections/AboutCTASection';


type PageProps = { language: 'ar' | 'en' };

const About: React.FC<PageProps> = ({ language }) => {
  const [sections, setSections] = useState<any[]>([]);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const savedData = localStorage.getItem('pageData_about');
    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);
        setSections(parsedData);
        console.log('Loaded updated data from localStorage for about page');
        console.log('Sections count:', parsedData.length);
      } catch (error) {
        console.error('Error parsing localStorage data:', error);
        setSections(pagesData.about?.sections || []);
      }
    } else {
      setSections(pagesData.about?.sections || []);
      console.log('Using original data from pagesData for about page');
    }
  }, [refreshKey]);

  const sectionComponents: Record<string, React.ComponentType<any>> = {
    HeroSection,
    VisionMissionSection,
    AboutPreview,
    AboutHeroSection,
    AboutCompanyOverviewSection,
    AboutQualitySafetySection,
    AboutProjectManagementSection,
    BusinessScopeSection,
    AboutVisionMissionGoalsSection,
    AboutCoreValuesSection,
    AboutWhyUsSection,
    AboutTestimonialsSection,
    AboutCTASection,
  };

  const reloadData = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <div className={`min-h-screen ${language === 'ar' ? 'font-cairo' : 'font-montserrat'}`} dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <div className="fixed top-4 right-4 z-50">
        <button
          onClick={reloadData}
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg shadow-lg"
          title="إعادة تحميل البيانات"
        >
          🔄 تحديث
        </button>
      </div>
      {sections.map((section, idx) => {
        const SectionComponent = sectionComponents[section.type];
        if (!SectionComponent) return null;
        return <SectionComponent key={idx} language={language} {...section.props} />;
      })}
    </div>
  );
};

export default About; 